import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
export default function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    ordered,
    reversed,
    start
  } = attributes;
  const TagName = ordered ? 'ol' : 'ul';
  return createElement(TagName, _extends({
    reversed: reversed,
    start: start
  }, useBlockProps.save()), createElement(InnerBlocks.Content, null));
}
//# sourceMappingURL=save.js.map